// Build an inline style for a cropped <img> from CMS focal-point + zoom values.
// `field` is the image field name; companion values are `${field}_pos` ("50% 30%")
// and `${field}_zoom` (number). Use inside an overflow-hidden container with object-cover.
export function imgStyle(item, field) {
  const style = {};
  const pos = item?.[`${field}_pos`];
  const zoom = Number(item?.[`${field}_zoom`]);
  if (pos) style.objectPosition = pos;
  if (zoom && zoom !== 1) style.transform = `scale(${zoom})`;
  return style;
}
